import { UPDATE_INCLUDED_CONTROLLER_QUESTIONS } from '#app/constants/forms.ts'
import { type State, type Action } from '#types/form/wizard.ts'

export function handleUpdateIncludedControllerQuestions<T>(
	state: State<T>,
	action: Action<T>,
): State<T> {
	if (
		action.type !== UPDATE_INCLUDED_CONTROLLER_QUESTIONS ||
		!('includedControllerQuestions' in state)
	) {
		return state
	}

	const { id, includedQuestions } = action
	const existingQuestion = state.includedControllerQuestions!.find(
		question => question.id === id,
	)

	let newQuestions
	if (existingQuestion) {
		newQuestions = state.includedControllerQuestions!.map(question =>
			question.id === id ? { id, includedQuestions } : question,
		)
	} else {
		newQuestions = state.includedControllerQuestions!.concat({
			id,
			includedQuestions,
		})
	}

	return {
		...state,
		includedControllerQuestions: newQuestions,
	}
}
